import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: (to) => {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
      const permCodes = userInfo.permCodes || []
      if (permCodes.includes('personalHomepage:view') || userInfo.userId === 1) {
        return '/personalHomepage'
      }
      // 如果没有首页权限，尝试跳转到第一个有权限的路由
      if (permCodes.includes('dashboard:view')) return '/dashboard'
      if (permCodes.includes('product:view')) return '/products'
      if (permCodes.includes('order:view')) return '/orders'
      return '/personalHomepage' // 默认还是 dashboard，但会被守卫拦截
    },
    children: [
      {
        path: 'personalHomepage',
        name: 'PersonalHomepage',
        component: () => import('@/views/PersonalHomepage.vue'),
        meta: { title: '个人主页'}
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '数据看板'}
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/ProductManage.vue'),
        meta: { title: '商品管理'}
      },
      {
        path: 'product-categories',
        name: 'ProductCategories',
        component: () => import('@/views/ProductCategoryManage.vue'),
        meta: { title: '分类管理'}
      },
      {
        path: 'lock-orders',
        name: 'LockOrders',
        component: () => import('@/views/LockOrderRecords.vue'),
        meta: { title: '锁仓单记录'}
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/OrderManage.vue'),
        meta: { title: '订单管理'}
      },
      {
        path: 'production-orders',
        name: 'ProductionOrders',
        component: () => import('@/views/ProductionOrderManage.vue'),
        meta: { title: '生产订单'}
      },
      {
        path: 'warehouses',
        name: 'Warehouses',
        component: () => import('@/views/WarehouseManage.vue'),
        meta: { title: '仓库管理'}
      },
      {
        path: 'inventory',
        name: 'Inventory',
        component: () => import('@/views/InventoryManage.vue'),
        meta: { title: 'SKU库存'}
      },
      {
        path: 'userInventory',
        name: 'userInventory',
        component: () => import('@/views/UserInventoryManage.vue'),
        meta: { title: '库存库存'}
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/FinanceManage.vue'),
        meta: { title: '财务管理'}
      },
      {
        path: 'recharges',
        name: 'FundRecharges',
        component: () => import('@/views/FundRechargeRecords.vue'),
        meta: { title: '充值记录', icon: 'el-icon-document', permCode: 'recharge:view' }
      },
      {
        path: 'withdraws',
        name: 'FundWithdraws',
        component: () => import('@/views/FundWithdrawRecords.vue'),
        meta: { title: '分销商提现记录'}
      },
      {
        path: 'wallet-logs',
        name: 'FundWalletLogs',
        component: () => import('@/views/FundWalletLogs.vue'),
        meta: { title: '分销商资金流水'}
      },
      {
        path: 'credit-logs',
        name: 'FundCreditLogs',
        component: () => import('@/views/FundCreditLogs.vue'),
        meta: { title: '信用卡资金流水'}
      },
      {
        path: 'salesman-withdraws',
        name: 'SalesmanWithdraws',
        component: () => import('@/views/SalesmanWithdrawRecords.vue'),
        meta: { title: '渠道商务提现记录'}
      },
      {
        path: 'salesman-wallet-logs',
        name: 'SalesmanWalletLogs',
        component: () => import('@/views/SalesmanWalletLogs.vue'),
        meta: { title: '渠道商务资金流水'}
      },
      {
        path: 'order-split',
        name: 'FundOrderSplitManage',
        component: () => import('@/views/FundOrderSplitManage.vue'),
        meta: { title: '分账管理'}
      },
      {
        path: 'sub-accounts',
        name: 'SubAccounts',
        component: () => import('@/views/SubAccountManage.vue'),
        meta: { title: '子账号管理'}
      },
      {
        path: 'channel/distributors',
        name: 'DistributorManage',
        component: () => import('@/views/DistributorManage.vue'),
        meta: { title: '分销商管理'}// 2
      },
      {
        path: 'distributor-apply-records',
        name: 'DistributorApplyRecord',
        redirect: 'channel/distributors?tab=apply'
      },
      {
        path: 'channel/distributor-levels',
        name: 'DistributorLevels',
        component: () => import('@/views/DistributorLevelManage.vue'),
        meta: { title: '分销商等级管理'}// 2
      },
      {
        path: 'channel/salesman-levels',
        name: 'SalesmanLevels',
        component: () => import('@/views/SalesmanLevelManage.vue'),
        meta: { title: '渠道商务等级管理'}// 2
      },
      {
        path: 'channel/distributor-apply-audit',
        name: 'DistributorApplyAudit',
        component: () => import('@/views/DistributorApplyAudit.vue'),
        meta: { title: '分销商申请审核'}// 2
      },
      {
        path: 'channel/suppliers',
        name: 'Suppliers',
        component: () => import('@/views/SupplierManage.vue'),
        meta: { title: '供应商管理'}// 2
      },
      {
        path: 'system/permissions',
        name: 'PermissionManage',
        component: () => import('@/views/PermissionManage.vue'),
        meta: { title: '菜单管理'}//1
      },
      {
        path: 'system/roles',
        name: 'RoleManage',
        component: () => import('@/views/RoleManage.vue'),
        meta: { title: '角色管理'}//1
      },
      {
        path: 'system/users',
        name: 'UserManage',
        component: () => import('@/views/UserManage.vue'),
        meta: { title: '用户管理' }//1
      },
      {
        path: 'system/express-companies',
        name: 'ExpressCompanies',
        component: () => import('@/views/ExpressCompanyManage.vue'),
        meta: { title: '物流公司管理'}// 2
      },
      {
        path: 'system/provinces',
        name: 'Provinces',
        component: () => import('@/views/ProvinceManage.vue'),
        meta: { title: '省份管理'}// 2
      },
      {
        path: 'system/product-spec-options',
        name: 'ProductSpecOptions',
        component: () => import('@/views/ProductSpecOptionManage.vue'),
        meta: { title: '颜色尺码维护'}// 2
      },
      {
        path: 'system/ai-fee-dictionary',
        name: 'AiFeeDictionary',
        component: () => import('@/views/AiFeeDictionaryManage.vue'),
        meta: { title: 'AI扣费字典维护'}// 2
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token')

  if (to.path === '/login') {
    next()
  } else if (!token) {
    next('/login')
  } else {
    // 根路径直接放行，让 redirect 处理
    if (to.path === '/') {
      next()
      return
    }
    next()
  }
})

export default router
